<template>
    <dl class="myo_search_list">
        <dt>{{ i18n.myoffice.MyMember.generation }}</dt>
        <dd>
            <span class="leg_input_box">
                <input type="text" name="level" id="level" :value="level" @input="get_level" class='' style="max-width:50%; width:100px;">
            </span>
            <span class="mini_notice"> ('0' {{ i18n.myoffice.all }})</span>
        </dd>
    </dl>
</template>

<script>
export default {
    name: "stepForm",
    data: () => ({
        i18n: window.i18n,
    }),
    props : {
      level : {
        type    : String,
        default : "2"
      },
    },
    methods: {
      get_level(event) {
        this.$emit('get_level', event.target.value);
      },
    }
}
</script>

<style scoped>

</style>
